import { BookOpenText, Calculator, FileClock, Hash, Layers3, ShieldCheck } from 'lucide-react';
import { shellCard } from './shared.jsx';

const iconByStep = {
  conceptos: BookOpenText,
  numeradores: Hash,
  listas: Layers3,
  reglas: ShieldCheck,
  simulador: Calculator,
  auditoria: FileClock,
};

export default function StepperTarifas({ steps, active, onSelect }) {
  return (
    <section className={`${shellCard} overflow-hidden p-4`}>
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-6">
        {steps.map((step, index) => {
          const Icon = iconByStep[step.tab] || Layers3;
          const current = active === step.tab;
          return (
            <button
              key={step.tab}
              type="button"
              aria-current={current ? 'step' : undefined}
              onClick={() => onSelect(step.tab)}
              className={`rounded-2xl border px-4 py-3 text-left transition ${current ? 'border-[rgba(var(--brand),0.55)] bg-[rgba(var(--brand),0.12)]' : 'border-[rgba(var(--border),0.45)] bg-[rgba(var(--subpanel),0.2)] hover:bg-[rgba(var(--subpanel),0.35)]'}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[rgba(var(--panel),0.52)] text-[rgb(var(--brand))]">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </div>
                <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${step.state === 'completo' ? 'bg-[rgba(var(--brand),0.18)] text-[rgb(var(--brand))]' : step.state === 'incompleto' ? 'bg-[rgba(var(--border),0.6)] text-[rgb(var(--fg))]' : 'bg-[rgba(var(--subpanel),0.65)] text-[rgba(var(--muted),0.95)]'}`}>
                  {step.state}
                </span>
              </div>
              <p className="mt-3 text-xs font-semibold uppercase tracking-[0.18em] text-[rgba(var(--muted),0.95)]">Paso {index + 1}</p>
              <p className="mt-2 text-sm font-semibold text-[rgb(var(--fg))]">{step.title}</p>
              <p className="mt-1 text-xs text-[rgba(var(--muted),0.95)]">{step.summary}</p>
              <p className="mt-3 text-xs text-[rgba(var(--fg),0.76)]">{step.countLabel}</p>
              <p className="mt-2 text-[11px] text-[rgba(var(--muted),0.95)]">Depende de: {step.dependsOn}</p>
              <p className="mt-1 text-[11px] text-[rgba(var(--muted),0.95)]">Sigue: {step.next}</p>
            </button>
          );
        })}
      </div>
    </section>
  );
}
